/**
 * Category Mapping Utilities
 * Handles mapping between system keys and French display names.
 * Canonical aliases live in src/catalog/legacyAliases.js.
 */

import {
  CATEGORY_NAME_ALIASES,
  canonicalizeCategoryKey,
} from '../catalog/legacyAliases';
import { categories } from '../catalog/categoryTree';

/** @deprecated Prefer getCategoryLabel / canonicalizeCategoryKey */
export const SYSTEM_KEY_TO_FRENCH = Object.fromEntries(
  Object.entries(categories).map(([key, cat]) => [key, cat.name])
);

/**
 * Full French/Arabic display name → system key map (tree labels + legacy aliases).
 * @deprecated Prefer canonicalizeCategoryKey(value, categories)
 */
export const FRENCH_TO_SYSTEM_KEY = Object.fromEntries([
  ...Object.entries(CATEGORY_NAME_ALIASES),
  ...Object.entries(categories).flatMap(([key, cat]) => {
    const rows = [];
    if (cat?.name) rows.push([cat.name, key]);
    if (cat?.nameAr) rows.push([cat.nameAr, key]);
    return rows;
  }),
]);

export const getFrenchCategoryName = (systemKey) => {
  const key = canonicalizeCategoryKey(systemKey, categories);
  return categories[key]?.name || systemKey;
};

export const getSystemCategoryKey = (frenchName) => {
  return canonicalizeCategoryKey(frenchName, categories);
};

/**
 * Checks if a product matches a category filter (handles both system keys and French names)
 */
export const matchesCategoryFilter = (product, filterCategory) => {
  if (!filterCategory) return true;

  const productKey = canonicalizeCategoryKey(product?.category, categories);
  const filterKey = canonicalizeCategoryKey(filterCategory, categories);
  if (productKey && filterKey && productKey === filterKey) return true;

  return product?.category === filterCategory || product?.category === getFrenchCategoryName(filterCategory);
};
